import { Deserializable } from '../../protocols/deserializable';

export class MostRecentInvite implements Deserializable {
  public id!: string;
  public email!: string;
  public memberId!: number;
  public employerId!: number;
  public verificationDate!: string | null;
  public lastInviteSentDate!: string | null;

  onDeserialize(): void {}
}
